import React from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons'
import Avatar from '../../paginas/img/avatar.jpg'
import HeaderTabla from '../componentes/HeaderTabla'
import BotonesFormulario from '../componentes/BotonesFormulario'
import moment from 'moment'

const VerUsuarios = ({ data, seleccionaRegistro }) => {

	const FormateaFecha = (dato) => {
		let fecha = moment(dato).format('YYYY-MM-DD')
		return fecha
	}


	return (
		<div>
			<MDBTable hover responsive>
				<HeaderTabla array={['Img', 'Estado', 'COD', 'Inscrip', 'Nombre', 'Usuario', 'Celular', 'Rol', '']} />
				<MDBTableBody>

					{data.map((item, index) => {
						return (
							<tr key={index}>
								<td><div className="img_user"><img src={Avatar} /></div></td>
								<td><div className={`estados ${item.activo}`} >{item.activo}</div></td>
								<td>{item.id}</td>
								<td>{FormateaFecha(item.fecha_ins)}</td>
								<td>{item.nombre}</td>
								<td style={{ wordWrap: 'break-word' }}>{item.usuario}</td>
								<td>{item.telefono}</td>
								<td>{item.roll}</td>
								<td className="tabla_funciones">
									<BotonesFormulario SeleccionarCategoria={seleccionaRegistro} item={item} Roll={'Admin'} />
								</td>
							</tr>
						)

					})}

				</MDBTableBody>
			</MDBTable>
		</div>
	)
}

export default VerUsuarios